var exports = {
  "vF": "AccountTab.module__emailRow___MExIWG",
  "c1": "AccountTab.module__emailText___MExIWG",
  "aO": "AccountTab.module__emailTextSelectable___MExIWG",
  "Rm": "AccountTab.module__toggleButton___MExIWG",
};

module.exports = exports;
